export default function (key = 'restauId') {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    return params.get(key);
}
